export const LIST_LOYALTY_TRANSACTIONS_REQUEST =
  'LIST_LOYALTY_TRANSACTIONS_REQUEST';
export const RESET_LOYALTY_TRANSACTION_QUERY =
  'RESET_LOYALTY_TRANSACTION_QUERY';
export const LOYALTY_TRANSACTION_REQUESTING = 'LOYALTY_TRANSACTION_REQUESTING';
export const LIST_LOYALTY_TRANSACTIONS_SUCCESS =
  'LIST_LOYALTY_TRANSACTIONS_SUCCESS';
export const RESET_LOYALTY_TRANSACTION_ISFETCHING =
  'RESET_LOYALTY_TRANSACTION_ISFETCHING';
